import { Button } from 'antd';
import { useState } from 'react';
import { postGameMigration } from '../../../api';
import { ModalWrap } from '../../component/modal-wrap';
import warnImage from '../../../assets/images/warn-yellow.png';
import { messageError, messageSuccess } from '../../../components/message';
import getFormatMessage from '../../../locales/get-format-message';

interface IProps {
  readonly gameId: string;
  readonly studioId: string;
  readonly gameName: string | null;
  readonly studioName: string | null;
  readonly onSuccess: () => void;
}

export const Migration = (props: IProps) => {
  const [envBtnLoading, setEnvBtnLoading] = useState<boolean>(false);
  const { gameId, studioId, gameName, studioName, onSuccess } = props;
  const [migrationModal, setMigrationModal] = useState<boolean>(false);
  const isDisabled = !gameId || !studioId;

  const handleMigration = async () => {
    setEnvBtnLoading(true);
    try {
      // console.log('currentGame,currentTargetStudio：', gameId, studioId);
      const res = await postGameMigration(gameId, studioId);
      if (res.code === 0) {
        messageSuccess(getFormatMessage('migration_success'));
        onSuccess();
        setMigrationModal(false);
      } else {
        messageError(getFormatMessage('migration_fail'));
      }
    } catch (err: any) {
      if (err?.apiError?.code === 101114) {
        messageError(getFormatMessage('fail_uid_of_studio'));
      } else if (err?.apiError?.code === -10000) {
        messageError(getFormatMessage('migration_temporarily_offline'));
      } else {
        messageError(getFormatMessage('migration_fail'));
      }
    }
    setEnvBtnLoading(false);
    return true;
  };

  const onClose = async () => {
    setMigrationModal(false);
    return false;
  };

  const makeSureMigration = () => {
    if (migrationModal) {
      return (
        <ModalWrap
          width="550px"
          loading={envBtnLoading}
          onOk={handleMigration}
          cancelText={getFormatMessage('cancel')}
          oKText={getFormatMessage('confirm')}
          onClose={onClose}
          title={
            <p className="fail-title">
              <img
                src={warnImage}
                alt="Warning"
                style={{ marginRight: '10px', marginTop: '-2px' }}
              />
              <span>{getFormatMessage('migration_title')}</span>
            </p>
          }
          className="edit-modal"
        >
          <div>
            {getFormatMessage('migrate_game_confirm_admin_desc', {
              params: {
                gameName,
                gameId,
                studioName,
                studioId,
              },
            })}
          </div>
        </ModalWrap>
      );
    }
  };

  return (
    <div>
      <Button
        disabled={isDisabled}
        className="gc-btn gc-btn-primary btn-admin"
        onClick={() => {
          setMigrationModal(true);
        }}
        style={{ marginTop: 25, marginLeft: 8 }}
      >
        {getFormatMessage('migration')}
      </Button>
      {makeSureMigration()}
    </div>
  );
};
